var __vue_script__, __vue_template__
require("!!./../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-182e255a&scoped=true!sass-loader?sourceMap!./../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./GroupMember.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!./../../../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./GroupMember.vue")
__vue_template__ = require("!!vue-html-loader!./../../../../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-182e255a!./../../../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./GroupMember.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) {
(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/main/body/info/GroupMember.vue
 ** module id = 387
 ** module chunks = 2
 **/